
    import { createApp } from 'vue';
    import { createRouter, createWebHashHistory } from "vue-router";
    import VueMobileDetection from 'vue-mobile-detection';
    import App from './assets/javascript/App.vue';
    import Content from "./assets/javascript/components/Content.vue";
    import FileContent from "./assets/javascript/components/FileContent.vue";
    import CameraCardContent from "./assets/javascript/components/CameraCardContent.vue";
    import NotFound from "./assets/javascript/components/NotFound.vue";
    import AiContent from "./assets/javascript/components/AiContent.vue";

    const routes = [
        { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },
        { path: '/ai', name: 'private.ai', component: AiContent },
        { path: '/', name: 'root', component: Content,
          children: [
            { path: '', name: 'public', alias:'/public', component: FileContent ,
              children: [
                { path: ':file_id/:file_name', name: 'public.directory', component: FileContent }
              ]
            },
            { path: '/private', name: 'private',component: FileContent,
              children: [
                { path: ':file_id/:file_name', name: 'private.directory', component: FileContent }
              ]
            },
            { path: '/private/camera_cards', name: 'private.camera_cards', component: CameraCardContent },
          ]
        }
    ];
    const router = createRouter({
      history: createWebHashHistory(),
      routes
    })

    const app = createApp(App);
    app.use(VueMobileDetection)
    app.use(router);
    app.provide('router',router);
    app.mount('#app');

  